export default "__VITE_ASSET__3e36f7fc__"